import { render, staticRenderFns } from "./Wordcloud.vue?vue&type=template&id=4d8cd6d2&"
import script from "./Wordcloud.vue?vue&type=script&lang=ts&"
export * from "./Wordcloud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports